<nav class="header">
    <div class="header-logo py-2">
        <app-logo />
    </div>
    <app-header-toolbar />
    <app-header-user class="ml-auto" />
</nav>
